import React from "react";
import Parse from "parse";
import { Button, Center, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import DeleteUserDialogComponent from "./DeleteUserDialogComponent";
import "./../StylesPages/profile.css";

function DeleteUser() {
  const navigate = useNavigate();

  const deleteUser = (e) => {
    const currentUser = Parse.User.current();
    if (currentUser) {
      currentUser.destroy().then(
        (myObject) => {
          navigate("/");
        },
        (error) => {}
      );
    }
  };
  return (
    <Center>
      <Flex direction={"column"} justify={"center"} align={"center"}>
        <Text
          fontFamily={"Sofia Pro"}
          fontSize="xl"
          fontWeight={"bold"}
          color="black"
          marginTop={"20px"}
        >
          Gestion du compte
        </Text>
        <Text
          fontFamily={"Sofia Pro"}
          fontSize="xs"
          color="black"
          w={"100%"}
          fontWeight={"light"}
          letterSpacing={0.1}
          lineHeight={1.1}
          marginTop={"30px"}
        >
          La supression de votre compte est définitive.
        </Text>

        <DeleteUserDialogComponent
          deleteUser={deleteUser}
        ></DeleteUserDialogComponent>
      </Flex>
    </Center>
  );
}

export default DeleteUser;
